// extracted by mini-css-extract-plugin
module.exports = {"container":"JobHeading_container__26V1P","heading":"JobHeading_heading__2BZ0z","sending":"JobHeading_sending__2ERLc"};